import { Injectable, signal } from '@angular/core';

export type NativeMenuSheet = 'profile' | 'settings' | 'help' | null;

@Injectable({
  providedIn: 'root',
})
export class NativeMenuService {
  private readonly _activeSheet = signal<NativeMenuSheet>(null);
  readonly activeSheet = this._activeSheet.asReadonly();

  open(sheet: NativeMenuSheet): void {
    this._activeSheet.set(sheet);
  }

  close(): void {
    this._activeSheet.set(null);
  }

  toggle(sheet: Exclude<NativeMenuSheet, null>): void {
    if (this._activeSheet() === sheet) {
      this._activeSheet.set(null);
    } else {
      this._activeSheet.set(sheet);
    }
  }
}
